import type { UserId } from "@nimble/datamodel/types/userId";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getUserSavedSearchesQueryKey } from "@/hooks/data/use-user-saved-searches";
import {
  createSavedSearch,
  CreateSavedSearchJson,
  deleteSavedSearch,
} from "@/lib/api-clients/candidate-api-client";

export default function useSaveSearchMutation(userId: UserId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (json: CreateSavedSearchJson) =>
      createSavedSearch(userId, json),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getUserSavedSearchesQueryKey(userId),
      });
    },
  });
}

export function useDeleteSavedSearchMutation(userId: UserId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) => deleteSavedSearch(userId, uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getUserSavedSearchesQueryKey(userId),
      });
    },
  });
}
